import React from "react";
import { Box, Typography } from "@mui/material";
import FolderOffIcon from '@mui/icons-material/FolderOff';

export const DataNotFound = ({ message }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            style={{ height: "100%", width: "100%", textAlign: "center", padding: "20px" }}
        >
            <FolderOffIcon style={{ fontSize: "100px", color: "#ccc" }} />
            <Typography variant="h6" style={{ marginTop: "20px" }}>
                { message ? message : "No hay datos disponibles" }
            </Typography>
        </Box>
    );
};
